import Vue from 'vue';
import store from './store';

import router from './router/router';

import App from './App.vue';
import VueGtag from 'vue-gtag';
import { empresa, empresas } from './store/empresas';

import { DateTime, Settings } from 'luxon';
import Datetime2 from 'vue-datetime'

import layouts from './layouts/*.vue';
import "@mdi/font/css/materialdesignicons.css";
import "/css/colors.less";
import "/css/page.less";
import 'vue-datetime/dist/vue-datetime.css'


import DownloadLink from './components/download-link.vue';
import { NumberFormatter, DateFormatter } from './plugins/filters';

import { App as CapacitorApp } from '@capacitor/app'

//if (/(www\.)?saoluiz.imb.br/igm.exec(window.location.host) && /\/area-do-cliente-nova\//igm.exec(location.pathname)) {
if (/(www\.)?saoluiz.imb.br/igm.exec(window.location.host) || empresa.domain === 'www.saoluiz.imb.br') {
    const data = new Date().toJSON();
    if (data < '2025-06-30T12') {
        if (/localhost/.exec(window.location.host)) {
            location.href = 'https://www.saoluiz.imb.br/area-do-cliente-antiga'    
        } else {
            location.href = location.href.replace(/\/area-do-cliente\//igm, '/area-do-cliente-antiga/')
        }
    }
    
}

CapacitorApp.getInfo().then((info) => { 
    //alert(info.id)
    //br.com.studiogt.access
   
})

Settings.defaultLocale = 'pt-BR';
Vue.use(Datetime2)

Vue.component('download-link', DownloadLink);

if (empresa.ga && empresa.ga.id) {
    Vue.use(VueGtag, {
        config: empresa.ga
    }, router);
}


for(name in layouts) {
    ((name, layouts) => {
        const component = layouts[name].default;    
        Vue.component(name+'Layout', component);        
    })(name, layouts);
}


Vue.use(DateFormatter)
Vue.use(NumberFormatter)


Vue.directive('nl2br', {
        inserted(el) {
            el.innerHTML = el.textContent.replace(/\n/g, "<br />");
        },
    }
)

Vue.directive('raw', {
    inserted(el) {
        el.innerHTML = el.textContent
    }
})

new Vue({
    store,
    router,
    render: h => h(App)
}).$mount('#app');

if (module.hot) {
    module.hot.accept();
}

window.addEventListener('click', e => {
    if ('_blank' == e.target.target) {
        window.open(e.target.href);
        e.preventDefault();
        e.stopPropagation();
    }
    if ('_system' == e.target.target) {
        window.open(e.target.href);
        e.preventDefault();
        e.stopPropagation();
    }
})

